export function EmailBisonIcon() {
  return <img src="/emailbison.png" alt="EmailBison" className="h-6 w-6" />;
}
